/**
 * Created by intellicar-rinas on 15/7/17.
 */
import axios from 'axios';
import {get} from './helperFunctions';

let reqMap = {};

const newReqMap = (uid) => {
    return reqMap[uid] = axios.CancelToken.source();
};

const checkReq = (uid) => {
    if(uid in reqMap){
       reqMap[uid].cancel(0);
    }
    return newReqMap(uid)
};

const isAuthValid =auth=> {
    return auth && ((!auth.loggedInAt || Date.now() - auth.loggedInAt > 1000 * 60 * 60 * 24 * 3) || 
        (auth.userinfo && (auth.userinfo.username || '').indexOf('zoomcar') !== -1 && Date.now() - auth.loggedInAt > 1000 * 60 * 60 * 24));
}

const $http = {

    post: function (api, params = {}, config = {}, uid = "NO_UID") {
        const auth =get("main-auth");

        if(auth && (!auth.loggedInAt || Date.now() - auth.loggedInAt > 1000 * 60 * 60 * 24 * 3)) {
            window.logout();
        
        }

        
        if(auth && api.indexOf("gettoken") === -1){
            params.token = auth.token;
        }

        if(uid !== "NO_UID"){
            config.cancelToken = checkReq(uid + api).token;
            // console.log(config);
        }
        return axios.post(api, params, config);
    },

    geo: function (api, params = {}, config = {}, uid = "NO_UID") {
        const auth = window.getAuth();

        if(auth && api.indexOf("gettoken") === -1){
            params.token = auth.token;
        }

        if(uid !== "NO_UID"){
            config.cancelToken = checkReq(uid + api).token;
            // console.log(config);
        }
        return axios.post(api, params, config);
    }

};

export default $http;